import { Component, Input, ViewChild } from '@angular/core';

import { ClienteAnaliseMercadoFilter } from '../../adapters';

import { ClienteAnaliseMercadoClienteListComponent } from '../../cliente';

@Component({
    selector: 'sgt-cliente-analise-mercado-perspectiva-rap',
    templateUrl: './cliente-analise-mercado-perspectiva-rap.component.html',
    styleUrls: ['./cliente-analise-mercado-perspectiva-rap.component.less']
})
export class ClienteAnaliseMercadoPerspectivaRAPComponent {
    @Input() isVisualizacaoModoList: boolean;
    @Input() filter: ClienteAnaliseMercadoFilter;

    @ViewChild('clienteList') clienteList: ClienteAnaliseMercadoClienteListComponent;

    /** Pesquisa as análises potencias dos clientes */
    search() {
        if (this.isVisualizacaoModoList) { // List
            this.clienteList?.search();
        }
    }
}
